// латинка → укр (спрощений трансліт)
const LAT2UA = {
  a:"а", b:"б", v:"в", h:"г", g:"ґ", d:"д", e:"е",
  ye:"є", ie:"є", e_uk:"е",
  jo:"йо", yo:"йо", zh:"ж",
  z:"з", y:"и", i:"і", ji:"ї", yi:"ї", j:"й", k:"к", l:"л", m:"м", n:"н",
  o:"о", p:"п", r:"р", s:"с", t:"т", u:"у", f:"ф", kh:"х", x:"кс", c:"ц", ch:"ч", sh:"ш", shch:"щ",
  yu:"ю", ju:"ю", ya:"я", ja:"я", q:"к", w:"в",
  ts:"ц",
  iu:"ю", ia:"я"
};

// трансліт токена (спершу багатолітерні)
function latinToUaToken(tok) {
  let s = tok.toLowerCase();
  const multi = [
    ["shch","щ"],
    ["kh","х"],
    ["ch","ч"],
    ["sh","ш"],
    ["zh","ж"],
    ["ye","є"], ["ie","є"],
    ["yo","йо"], ["jo","йо"],
    ["yu","ю"], ["ju","ю"], ["iu","ю"],
    ["ya","я"], ["ja","я"], ["ia","я"],
    ["ts","ц"]
  ];
  for (const [k,v] of multi) s = s.split(k).join(v);
  s = s.replace(/[abvhgdeziyklmnoprstufxcqw]/g, (m)=>LAT2UA[m]||m);
  return s;
}

// EN→UA «збита розкладка» (qwerty → йцукен)
const EN2UA_LAYOUT = {
  q:"й", w:"ц", e:"у", r:"к", t:"е", y:"н", u:"г", i:"ш", o:"щ", p:"з", "[":"х", "]":"ї",
  a:"ф", s:"і", d:"в", f:"а", g:"п", h:"р", j:"о", k:"л", l:"д", ";":"ж", "'":"є",
  z:"я", x:"ч", c:"с", v:"м", b:"и", n:"т", m:"ь", ",":"б", ".":"ю", "/":"."
};
function fixLayoutToken(tok){
  return tok.split("").map(ch=>{
    const low = ch.toLowerCase();
    const rep = EN2UA_LAYOUT[low];
    if(!rep) return ch;
    return (ch===low)?rep:rep.toUpperCase();
  }).join("");
}

// базова нормалізація
export function normalizeText(input){
  if(!input) return "";
  let s = String(input)
    .normalize("NFC")
    .replace(/[\u2019\u2018\u2032']/g,"’")
    .toLowerCase()
    .replace(/[^\p{L}\p{N}\s%\/\-_]+/gu," ")
    .replace(/\s+/g," ")
    .trim();
  return s;
}

// розширення токенів (трансліт + розкладка)
export function expandTokens(text){
  const base = normalizeText(text);
  if (!base) return [];
  const toks = base.split(" ").filter(Boolean);

  const variants = new Set();
  for (const t of toks){
    variants.add(t);
    const tl = latinToUaToken(t);
    if (tl && tl!==t) variants.add(tl);
    const fl = fixLayoutToken(t).toLowerCase();
    if (fl && fl!==t) variants.add(fl);
  }
  return Array.from(variants);
}
